export default interface IPlayList {
    name: string;
    playList: string;
}
